import { ManualActions } from 'leash/pages/details/detailsHeader/ManualActionsMenu';
import {
  TravelEligibility,
  TravelMethodIdType,
  TravelPackagesHistory,
  TravelTypeIdType,
} from 'leash/types';
import { Address, TravelPlan, TravelProposal } from 'types';
import { apiGetRequest, apiPostRequest, apiPutRequest } from 'utilities/http/api/apiHttp';

export interface TravelProposalResponse {
  travelProposal: TravelProposal;
}
export const apiPackage = {
  getPackages: () => apiGetRequest<{ travelPlans: TravelPlan[] }>(`travel/planning`),

  getById: (orderId: string) => {
    return apiGetRequest<{ travelPlan: TravelPlan }>(`travel/planning/${orderId}`);
  },

  getHistoryPackages: (travelPackageId: number) => {
    return apiGetRequest<{ history: TravelPackagesHistory[] }>(
      `travel/${travelPackageId}/history`,
    );
  },

  updateTravelMethod: (
    orderId: number,
    travelTypeId: TravelTypeIdType,
    travelMethodId: TravelMethodIdType,
  ) => {
    return apiPutRequest<unknown>(
      `order/${orderId}/travel-type/${travelTypeId}`,
      null,
      `travel_method_id=${travelMethodId}`,
    );
  },

  rejectTravelProposal: (
    travelId: number,
    rejectReasonId: number,
    rejectedBy: ManualActions,
    note?: string,
  ) => {
    const rejection = {
      rejectionAuthority: rejectedBy,
      reasonIds: [rejectReasonId],
      otherReason: note,
      note,
    };

    const otherReasonId = 8;
    if (rejectReasonId !== otherReasonId) {
      delete rejection.otherReason;
    } else if (rejectReasonId === otherReasonId || !note) {
      delete rejection.note;
    }
    return apiPostRequest(`travel/${travelId}/reject-travel-plan`, { rejection });
  },

  confirmTravelProposal: (travelId: number) => {
    return apiPostRequest(`travel/${travelId}/confirm-travel-plan`, null);
  },

  updateTravelProposal: (
    travelId: number,
    travelProposalId: number,
    travelProposal: TravelProposal,
  ) => {
    return apiPutRequest<TravelProposalResponse>(
      `travel/${travelId}/travel-proposal/${travelProposalId}`,
      {
        travelProposal,
      },
    );
  },

  createTravelProposal: (travelId: number, travelProposal: TravelProposal) => {
    return apiPostRequest<TravelProposalResponse>(`travel/${travelId}/travel-proposal`, {
      travelProposal,
    });
  },

  proposeTravelProposal: (travelId: number, travelProposal: TravelProposal) => {
    return apiPostRequest<{ travelProposal: TravelProposal }>(
      `travel/${travelId}/propose-travel-plan`,
      {
        travelProposal,
      },
    );
  },

  finalize: (travelPackageId: number) => {
    return apiPostRequest<TravelResponseWorkflowEntity>(
      `travel/${travelPackageId}/finalize-travel-plan`,
      null,
    );
  },

  getTravelEligibility: (puppyId: number, address: Address) => {
    let appendParameters = `puppyId=${puppyId}`;
    appendParameters += `&address=${
      address.address ? address.address.replace(/#/g, '') : address.address
    }`;
    appendParameters += `&city=${address.city}&stateAbbr=${address.state}`;
    appendParameters += `&postalCode=${address.postalCode}&countryAbbr=${address.country}`;
    return apiGetRequest<{ eligibility: TravelEligibility[] }>(
      `travel/eligibility`,
      appendParameters,
    );
  },

  revertRejectionTravelPlan: (travelPackageId: number) => {
    return apiPostRequest<TravelResponseWorkflowEntity>(
      `travel/${travelPackageId}/revert-rejection-of-travel-plan`,
    );
  },
};

interface TravelResponseWorkflowEntity {
  travel: {
    workflowEntity: {
      currentStatus: { name: string; workflowId: 3 };
    };
  };
}
